import {useTheme} from '@mui/material';
import {HomeEnum} from 'presentation/constants';
import {usePersonalData, usePrint} from 'presentation/hooks';
import {useCalendarEvent} from 'presentation/modules/booking/shared/hooks/useCalendarEvent';
import {useMediaQueries} from 'presentation/pages';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {useWatchTutorial} from 'presentation/pages/private/hooks/useWatchTutorial';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useNavigate} from 'react-router-dom';

export function useTelehealthConfirmationBookingContent(
	bookedAppointment: AppointmentsHomeStateType,
) {
	const navigate = useNavigate();
	const {isMobile, isTablet, betweenMobileAndDesktop, isDesktop} = useMediaQueries();
	const {isPrinting, printContent, printRef, shareContent, isSharing} = usePrint();
	const calendarEvent = useCalendarEvent(bookedAppointment);
	const {colors} = useTheme();
	const {userName} = usePersonalData();
	const accountData = useAccountDataStore(state => state.accountData);
	const {handleWatchTutorial, tutorialLink} = useWatchTutorial();

	const beneficiaryName = userName;
	const planName = accountData.beneficiary.nmPlano;

	const {formattedDateWithWeekday, hour, dateOnly, providerName, specialtyName, protocolNumber} =
		bookedAppointment;

	const goToHome = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	return {
		isMobile,
		isTablet,
		betweenMobileAndDesktop,
		isDesktop,
		isPrinting,
		printContent,
		printRef,
		calendarEvent,
		colors,
		formattedDateWithWeekday,
		hour,
		date: dateOnly,
		providerName,
		specialtyName,
		protocolNumber,
		beneficiaryName,
		planName,
		tutorialLink,
		handleWatchTutorial,
		goToHome,
		shareContent,
		isSharing,
	};
}
